import { render, staticRenderFns } from "./assign-school.vue?vue&type=template&id=f1bed94e&scoped=true&"
import script from "./assign-school.ts?vue&type=script&lang=ts&"
export * from "./assign-school.ts?vue&type=script&lang=ts&"
import style0 from "./assign-school.scss?vue&type=style&index=0&id=f1bed94e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bed94e",
  null
  
)

export default component.exports